import React from 'react';
import SEO from '../../common/SEO';
import HeaderTwo from '../../common/header/HeaderTwo';
import FooterOne from '../../common/footer/FooterOne';
import Banner from '../../components/solutions/energy/Banner';
import AISolutions from '../../components/solutions/energy/AISolutions';
import CaseStudy from '../../components/solutions/energy/CaseStudy';
import EnergyTransformation from '../../components/solutions/energy/EnergyTransformation';
import Advantage from '../../components/solutions/energy/Advantage';
import FooterBanner from '../../components/solutions/energy/FooterBanner';

const Energy = () => {

  return (
    <>
      <SEO
				title="Energy Industry Solutions"
				description="Powering a Smarter, Safer, and More Resilient Energy Future with Edge AI"
      />
      <HeaderTwo styles="header-transparent header-style-2" searchDisable />
      <Banner />
      <AISolutions />
      <CaseStudy />
      <EnergyTransformation />
      <Advantage />
      <FooterBanner />
      <FooterOne />
    </>
  )
}

export default Energy;